import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {

  connectedCallback() {

    super.connectedCallback();

    document.addEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

  }

  disconnectedCallback() {

    super.disconnectedCallback();

    document.removeEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

  }


  /* =========================================
     AGE GATE
  ========================================= */

  #setupAgeGate = () => {

    const checkoutBtn =
      this.querySelector('[name="checkout"]');

    const ageCheckbox =
      this.querySelector('#age-verification-checkbox');

    const ageGateWrapper =
      this.querySelector('#age-gate-wrapper');

    if (
      checkoutBtn &&
      ageCheckbox &&
      ageGateWrapper
    ) {

      // Move above checkout button
      checkoutBtn.parentNode.insertBefore(
        ageGateWrapper,
        checkoutBtn
      );

      // Always show
      ageGateWrapper.style.display = 'flex';

      // Initial state
      checkoutBtn.disabled = !ageCheckbox.checked;

      // Remove old listener
      ageCheckbox.onchange = null;

      // Toggle checkout button
      ageCheckbox.onchange = () => {

        checkoutBtn.disabled =
          !ageCheckbox.checked;

      };

    }

  };


  /* =========================================
     HANDLE CART ADD
  ========================================= */

  #handleCartAdd = () => {

    if (this.hasAttribute('auto-open')) {

      this.open();

    }

  };


  /* =========================================
     OPEN DRAWER
  ========================================= */

  open() {

    this.showDialog();

    // Setup age gate
    this.#setupAgeGate();

    // Re-init features
    requestAnimationFrame(() => {

      if (
        typeof window.initUpsellSlider === 'function'
      ) {

        window.initUpsellSlider();

      }

      if (
        typeof window.initUpsellToggle === 'function'
      ) {

        window.initUpsellToggle();

      }

    });

  }


  close() {

    this.closeDialog();

  }

}


/* =========================================
   REGISTER COMPONENT
========================================= */

if (!customElements.get('cart-drawer-component')) {

  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );

}


/* =========================================
   UPSELL SLIDER
========================================= */

window.initUpsellSlider = function () {

  const slider =
    document.querySelector(".cart-upsell-slider");

  const slides =
    document.querySelectorAll(".upsell-card");

  const next =
    document.querySelector(".upsell-next");

  const prev =
    document.querySelector(".upsell-prev");

  if (
    !slider ||
    !next ||
    !prev ||
    slides.length === 0
  ) return;

  // Reset listeners
  next.onclick = null;
  prev.onclick = null;

  let currentIndex = 0;

  function updateSlider() {

    slider.scrollTo({
      left: slider.offsetWidth * currentIndex,
      behavior: "smooth"
    });

    prev.disabled =
      currentIndex === 0;

    next.disabled =
      currentIndex === slides.length - 1;

  }

  updateSlider();

  next.onclick = () => {

    if (
      currentIndex <
      slides.length - 1
    ) {

      currentIndex++;

      updateSlider();

    }

  };

  prev.onclick = () => {

    if (currentIndex > 0) {

      currentIndex--;

      updateSlider();

    }

  };


  /* =========================================
     UPSELL ADD TO CART
  ========================================= */

  document.querySelectorAll(".upsell-add-btn").forEach(btn => {

    btn.onclick = function () {

      // Save reopen flag
      sessionStorage.setItem(
        'reopenCartDrawer',
        'true'
      );

      fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          id: this.dataset.variantId,
          quantity: 1
        })

      }).then(() => {

        // Reload page
        window.location.href =
          window.location.pathname +
          '?openCartDrawer=true';

      });

    };

  });

};


/* =========================================
   UPSELL TOGGLE
========================================= */

window.initUpsellToggle = function () {

  const arrow =
    document.querySelector(".down_arrow");

  const upsellMain =
    document.querySelector(".cart-upsell-main");

  if (!arrow || !upsellMain) return;

  arrow.onclick = null;

  arrow.onclick = function (e) {

    e.preventDefault();

    const isHidden =
      getComputedStyle(upsellMain).display === "none";

    upsellMain.style.display =
      isHidden ? "flex" : "none";

    arrow.classList.toggle(
      "is-active",
      !isHidden
    );

  };

};


/* =========================================
   INITIAL LOAD
========================================= */

document.addEventListener('DOMContentLoaded', () => {

  // Init slider
  if (
    typeof window.initUpsellSlider === 'function'
  ) {

    window.initUpsellSlider();

  }

  // Init toggle
  if (
    typeof window.initUpsellToggle === 'function'
  ) {

    window.initUpsellToggle();

  }


  /* =========================================
     FIX AGE GATE ON EVERY OPEN
  ========================================= */

  const drawer =
    document.querySelector('cart-drawer-component');

  if (drawer && typeof drawer.open === 'function') {

    const originalOpen =
      drawer.open.bind(drawer);

    drawer.open = function () {

      originalOpen();

      requestAnimationFrame(() => {

        const checkoutBtn =
          drawer.querySelector('[name="checkout"]');

        const ageCheckbox =
          drawer.querySelector('#age-verification-checkbox');

        const ageGateWrapper =
          drawer.querySelector('#age-gate-wrapper');

        if (
          checkoutBtn &&
          ageCheckbox &&
          ageGateWrapper
        ) {

          checkoutBtn.parentNode.insertBefore(
            ageGateWrapper,
            checkoutBtn
          );

          ageGateWrapper.style.display = 'flex';

          checkoutBtn.disabled =
            !ageCheckbox.checked;

          ageCheckbox.onchange = () => {

            checkoutBtn.disabled =
              !ageCheckbox.checked;

          };

        }

      });

    };

  }


  /* =========================================
     REOPEN CART AFTER RELOAD
  ========================================= */

  const params =
    new URLSearchParams(window.location.search);

  const shouldOpen =
    params.get('openCartDrawer');

  if (shouldOpen !== 'true') return;

  const openDrawer = () => {

    const drawer =
      document.querySelector('cart-drawer-component');

    if (!drawer) return false;

    if (typeof drawer.open === 'function') {

      drawer.open();

      // Clean URL
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );

      return true;

    }

    return false;

  };

  // Try instantly
  if (openDrawer()) return;

  // Fallback observer
  const observer = new MutationObserver(() => {

    if (openDrawer()) {

      observer.disconnect();

    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});